import type { VoidComponent } from "solid-js";
import type { RegisterableHotkey } from "@tanstack/solid-hotkeys";
import { formatForDisplay } from "@tanstack/solid-hotkeys";

type KbdProps = { hotkey: RegisterableHotkey };

export const Kbd: VoidComponent<KbdProps> = (props) => (
  <kbd class="inline-flex items-center rounded-sm border border-default bg-surface-default px-1.5 py-px font-sans text-small-regular text-secondary pointer-coarse:hidden">
    {formatForDisplay(props.hotkey)}
  </kbd>
);
